export default "__VITE_PUBLIC_ASSET__04da6d27__"